export const SET_LAST_ROUTE = 'SET_LAST_ROUTE'
export const SET_LAST_ROUTE_DATA = 'SET_LAST_ROUTE_DATA'
export const HIDE_GLOBAL_TIMER = 'HIDE_GLOBAL_TIMER'
export const SHOW_GLOBAL_TIMER = 'SHOW_GLOBAL_TIMER'
